import { Heading, Input, Stack, useToast } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PrimayButton } from "../../components/Button";
import { useStores } from "../../hooks/useStores";
import { SettingsEnum } from "../../types";

export const CalendlySettingsForm: React.FC = observer(() => {
  const { session } = useStores();
  const toast = useToast();
  const { t } = useTranslation();

  const [editedSessionCoachingUrl, setEditedSessionCoachingUrl] = useState("");
  const [editedLiveTrainingUrl, setEditedLiveTrainingUrl] = useState("");
  const [
    editedPersonalTrainerActiveSubUrl,
    setEditedPersonalTrainerActiveSubUrl,
  ] = useState("");
  const [
    editedPersonalTrainerInactiveSubUrl,
    setEditedPersonalTrainerInactiveSubUrl,
  ] = useState("");

  const handleSubmitSessionCoachingUrl = useCallback(async () => {
    try {
      await session.updateSettings(
        "CALENDLY_COACHING_SESSION_URL",
        editedSessionCoachingUrl || ""
      );
      toast({
        title: t("common.actionExecutedSuccessfully"),
        position: "bottom",
        status: "success",
      });
    } catch (err) {
      toast({
        title: t("common.error"),
        position: "bottom",
        status: "error",
      });
    }
  }, [editedSessionCoachingUrl, session, t, toast]);

  const handleSubmitLiveTrainingUrl = useCallback(async () => {
    try {
      await session.updateSettings(
        "CALENDLY_LIVE_TRAINING_URL",
        editedLiveTrainingUrl || ""
      );
      toast({
        title: t("common.actionExecutedSuccessfully"),
        position: "bottom",
        status: "success",
      });
    } catch (err) {
      toast({
        title: t("common.error"),
        position: "bottom",
        status: "error",
      });
    }
  }, [editedLiveTrainingUrl, session, t, toast]);

  const handleSubmitPersonalTrainerActiveSubUrl = useCallback(async () => {
    try {
      await session.updateSettings(
        SettingsEnum.CALENDLY_BOOK_PERSONAL_TRAINER_ACTIVE_SUBSCRIPTION,
        editedPersonalTrainerActiveSubUrl || ""
      );
      toast({
        title: t("common.actionExecutedSuccessfully"),
        position: "bottom",
        status: "success",
      });
    } catch (err) {
      toast({
        title: t("common.error"),
        position: "bottom",
        status: "error",
      });
    }
  }, [editedPersonalTrainerActiveSubUrl, session, t, toast]);

  const handleSubmitPersonalTrainerInactiveSubUrl = useCallback(async () => {
    try {
      await session.updateSettings(
        SettingsEnum.CALENDLY_BOOK_PERSONAL_TRAINER_INACTIVE_SUBSCRIPTION,
        editedPersonalTrainerInactiveSubUrl || ""
      );
      toast({
        title: t("common.actionExecutedSuccessfully"),
        position: "bottom",
        status: "success",
      });
    } catch (err) {
      toast({
        title: t("common.error"),
        position: "bottom",
        status: "error",
      });
    }
  }, [editedPersonalTrainerInactiveSubUrl, session, t, toast]);

  return (
    <Stack marginTop={"2rem"}>
      <Heading as="h5" size="sm" marginBottom={"1rem"}>
        {t("screens.adminSettings.calendly")}
      </Heading>

      <Stack>
        <Heading as="h6" size="xs">
          {t("screens.adminSettings.calendarSessionCoaching")}
        </Heading>
        <Stack gridGap={"1"} marginBottom={"2rem"} marginTop={"1rem"}>
          <Input
            value={
              editedSessionCoachingUrl.length > 0
                ? editedSessionCoachingUrl
                : session.calendlySessionCoachingUrl?.value || ""
            }
            onChange={(e) => setEditedSessionCoachingUrl(e.target.value)}
          />

          <PrimayButton
            onClick={handleSubmitSessionCoachingUrl}
            isLoading={false}
            disabled={editedSessionCoachingUrl.length === 0}
          >
            {t("common.save")}
          </PrimayButton>
        </Stack>
      </Stack>

      <Stack>
        <Heading as="h6" size="xs">
          {t("screens.adminSettings.calendlyLiveTraining")}
        </Heading>
        <Stack gridGap={"1"} marginBottom={"2rem"} marginTop={"1rem"}>
          <Input
            value={
              editedLiveTrainingUrl.length > 0
                ? editedLiveTrainingUrl
                : session.calendlyLiveTrainingUrl?.value || ""
            }
            onChange={(e) => setEditedLiveTrainingUrl(e.target.value)}
          />

          <PrimayButton
            onClick={handleSubmitLiveTrainingUrl}
            isLoading={false}
            disabled={editedLiveTrainingUrl.length === 0}
          >
            {t("common.save")}
          </PrimayButton>
        </Stack>
      </Stack>

      <Stack>
        <Heading as="h6" size="xs">
          {t("screens.adminSettings.calendlyBookingPersonalTrainerActiveSub")}
        </Heading>
        <Stack gridGap={"1"} marginBottom={"2rem"} marginTop={"1rem"}>
          <Input
            value={
              editedPersonalTrainerActiveSubUrl.length > 0
                ? editedPersonalTrainerActiveSubUrl
                : session.calendlyBookPersonalTrainerActiveSubscription
                    ?.value || ""
            }
            onChange={(e) =>
              setEditedPersonalTrainerActiveSubUrl(e.target.value)
            }
          />

          <PrimayButton
            onClick={handleSubmitPersonalTrainerActiveSubUrl}
            isLoading={false}
            disabled={editedPersonalTrainerActiveSubUrl.length === 0}
          >
            {t("common.save")}
          </PrimayButton>
        </Stack>
      </Stack>

      <Stack>
        <Heading as="h6" size="xs">
          {t("screens.adminSettings.calendlyBookingPersonalTrainerInActiveSub")}
        </Heading>
        <Stack gridGap={"1"} marginBottom={"2rem"} marginTop={"1rem"}>
          <Input
            value={
              editedPersonalTrainerInactiveSubUrl.length > 0
                ? editedPersonalTrainerInactiveSubUrl
                : session.calendlyBookPersonalTrainerInctiveSubscription
                    ?.value || ""
            }
            onChange={(e) =>
              setEditedPersonalTrainerInactiveSubUrl(e.target.value)
            }
          />

          <PrimayButton
            onClick={handleSubmitPersonalTrainerInactiveSubUrl}
            isLoading={false}
            disabled={editedPersonalTrainerInactiveSubUrl.length === 0}
          >
            {t("common.save")}
          </PrimayButton>
        </Stack>
      </Stack>
    </Stack>
  );
});
